(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("pageList", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/customPages/pageListView.html",
            controller: ["pagesResource", "DTOptionsBuilder", "$translate", "$scope", "$sessionStorage", "$state", "$compile", "_", PageListCtrl],
            controllerAs: "vm"
        };
        function PageListCtrl(pagesResource, DTOptionsBuilder, $translate, $scope, $sessionStorage, $state, $compile, _) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                return pagesResource.query().$promise;
            })
                .withOption("createdRow", function (row, data) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
                row.id = data.id;
            })
                .withOption("headerCallback", function (header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [1, "desc"])
                .withPaginationType("full_numbers")
                .withOption("fnDrawCallback", function () {
                $sessionStorage.pagesFilter = { search: vm.dtSearch };
            })
                .withOption("rowCallback", rowCallback)
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": null,
                    "defaultContent": "",
                    "class": "control",
                    "sortable": false,
                    "targets": 0
                },
                {
                    "data": "name",
                    "title": $translate.instant("common.lists.pageName")
                },
                {
                    "data": "friendlyUrl",
                    "title": $translate.instant("common.lists.friendlyUrl"),
                    "render": function (data, _type, full) {
                        if (full.isHomePage)
                            return $translate.instant("settings.customPages.pageForm.setAsHomePage");
                        return data;
                    }
                },
                {
                    "data": "enabledLocalizations",
                    "title": $translate.instant("common.published"),
                    "sortable": false,
                    "render": function (data, _type, full) {
                        var isPublishedBuilder = "";
                        _.each(data, function (tenantEnabled) {
                            var isPublishedLocalization = _.find(full.isPublishedLocalization, { localizationId: tenantEnabled.id });
                            if (isPublishedLocalization) {
                                if (isPublishedLocalization.isPublished)
                                    isPublishedBuilder += "<span class='m-r-10'><i class='f-s-16 ion ion-android-checkbox-outline m-r-5'></i>" + tenantEnabled.languageCulture + "</span>";
                                else
                                    isPublishedBuilder += "<span class='m-r-10'><i class='f-s-16 ion ion-android-checkbox-outline-blank m-r-5'></i>" + tenantEnabled.languageCulture + "</span>";
                            }
                            else
                                isPublishedBuilder += "<span class='m-r-10'><i class='f-s-16 ion ion-android-checkbox-outline-blank m-r-5'></i>" + tenantEnabled.languageCulture + "</span>";
                        });
                        return isPublishedBuilder;
                    }
                }
            ];
            if ($sessionStorage.pagesFilter) {
                vm.dtSearch = $sessionStorage.pagesFilter.search;
            }
            else {
                vm.dtSearch = "";
            }
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
            };
            vm.rowClickHandler = function (id) {
                $state.go("main.settings.customPagesEditPage", { id: id });
            };
            function rowCallback(nRow, data) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    vm.rowClickHandler(data.id);
                });
                return nRow;
            }
            vm.search = function (value) {
                $sessionStorage.pagesFilter = {
                    search: vm.dtSearch
                };
                vm.dtInstance.DataTable.search(value).draw();
            };
        }
    });
}());
